"use client";

import { useEffect, useRef, useState } from "react";
import { useAuth as useWorkOSAuth } from "@workos-inc/authkit-nextjs/components";
import { useMutation } from "convex/react";
import { api } from "@/convex/_generated/api";

export function AuthSync() {
  const { user } = useWorkOSAuth();
  const upsertUser = useMutation(api.users.upsertUser);
  const syncedUserIds = useRef(new Set<string>());
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    // Only sync if we have a user and haven't already synced this user ID
    if (user && !syncedUserIds.current.has(user.id) && !isProcessing) {
      setIsProcessing(true);

      // Mark this user ID as synced immediately to prevent duplicate requests
      syncedUserIds.current.add(user.id);

      upsertUser({
        email: user.email,
        name:
          user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : user.firstName || user.email,
        profileComplete: false,
      })
        .then(() => {
          // Successfully synced
          setIsProcessing(false);
        })
        .catch((error) => {
          console.error("Error upserting user:", error);
          // Remove from set on error so it can be retried
          syncedUserIds.current.delete(user.id);
          setIsProcessing(false);
        });
    }
  }, [user, upsertUser, isProcessing]);

  return null;
}
